import React from "react";
import { getGalleryImages } from "../api/ImageGeneration";

const UserImageContext = React.createContext();

const UserImageProvider = ({ children }) => {
  const [savedImages, setSavedImages] = React.useState([]);
  const [totalSavedImages, setTotalSavedImages] = React.useState(
    savedImages.length
  );
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [postsPerPage, setPostsPerPage] = React.useState(savedImages.length);
  const [currentSavedImages, setCurrentSavedImages] =
    React.useState(savedImages);

  const paginate = async ({ selected }) => {
    const nextPage = selected + 1;
    setCurrentPage(nextPage);
    await getGalleryImages(nextPage);
  };

  const truncateTextWithEllipsis = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    } else {
      return text;
    }
  };

  const getSavedImages = async (page) => {
    setLoading(true);

    try {
      const response = await getGalleryImages(page);
      if (response.data.success) {
        setSavedImages(response.data.data);
        if (page === 1) {
          setPostsPerPage(response.data.data.length);
        }
        setCurrentSavedImages(response.data.data);
        setTotalSavedImages(response.data.itemsCount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <UserImageContext.Provider
      value={{
        getSavedImages,
        savedImages,
        loading,
        totalSavedImages,
        currentSavedImages,
        postsPerPage,
        currentPage,
        truncateTextWithEllipsis,
        paginate,
      }}
    >
      {children}
    </UserImageContext.Provider>
  );
};

export { UserImageContext, UserImageProvider };
